export function getStars(max, value) {
  // whole stars
  const stars = [];

  for (let index = 0; index < Math.floor(value); index++) {
    stars.push(1);
  }

  // half stars
  const remainder = value % 1;
  if (remainder > 0) {
    if (remainder <= 0.5) {
      stars.push(0.5);
    } else {
      stars.push(1);
    }
  }

  // fill remaining empty stars
  for (let index = stars.length; index < max; index++) {
    stars.push(0);
  }

  return stars;
}
